import type { Payment } from 'paintscout'

export function getRefundableAmount(payment: Payment, allPayments: Payment[]): number {
  if (!payment.id || !payment.amount) return 0

  const alreadyRefunded = allPayments
    .filter((p) => p.forPaymentId === payment.id)
    .reduce((sum, p) => sum + Math.abs(p.amount), 0)

  return Math.max(0, payment.amount - alreadyRefunded)
}
